var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"spinner-loader"},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"indeterminate":"","color":_vm.color}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }